import type { ReactNode } from 'react';
import Eyebrow from './Eyebrow';
import ContactLine from './ContactLine';

interface Props {
  eyebrow: string;
  heading: string;
  body: string;
  action?: ReactNode;
}

/**
 * Full-screen centered state for a bundle link that can't be shown — 404,
 * 410 (replaced), 423 (archived), or a transient load failure. Shared by
 * BundleHub and BundleScriptView so a rotated/archived/unknown bundle reads
 * identically regardless of which URL (hub or in-script) a client landed on.
 * Mirrors ClientReview's own error-page pattern.
 */
export default function BundleErrorState({ eyebrow, heading, body, action }: Props) {
  return (
    <main className="min-h-screen bg-page text-fg flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <Eyebrow accent>{eyebrow}</Eyebrow>
        <h1 className="font-display font-bold text-[40px] leading-[1.05] tracking-[-0.02em] mt-3 mb-4">
          {heading}
        </h1>
        <p className="text-muted leading-[1.55]">{body}</p>
        {action}
        <ContactLine className="mt-4" />
      </div>
    </main>
  );
}
